import { useQuery } from '@tanstack/react-query';

import { ensureAgentHubBrands } from '~/consts/agentHub';

import useCurrentTenant from '~/hooks/useCurrentTenant';

import { listEOI } from '~/services/AgentHub/AgentService';

import { ListEoiParams } from '~/types/services/agentHub';

export function useListEoi({ page, pageSize, status, regionCode, search }: ListEoiParams) {
  const brand = useCurrentTenant();
  return useQuery({
    placeholderData: (prev) => {
      return {
        rows: prev?.rows ?? [],
        total: prev?.total ?? 0,
      };
    },
    queryKey: ['list-eoi', page, pageSize, status, regionCode, search, brand.tenant.brand],
    queryFn: async () => {
      return await listEOI({
        ...(regionCode && { regionCode }),
        ...(search && { search }),
        brand: ensureAgentHubBrands(brand.tenant.brand),
        page: page.toString(),
        pageSize: pageSize.toString(),
        ...(status && { status }),
      });
    },
  });
}
